import axios from 'axios';
import CryptoJS from 'crypto-js';
import { TzWalletSystem } from '~/types/common';

const encrypt = (id: string) => {
  const keyWordArray = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_TZ_WALLET_ENCRYPT_KEY || '');
  const ivWordArray = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_TZ_WALLET_ENCRYPT_IV || '');

  const encrypted = CryptoJS.AES.encrypt(id, keyWordArray, {
    iv: ivWordArray,
    mode: CryptoJS.mode.CBC,
  });

  return encrypted.toString();
};

export default async function tzWalletUserQuery(
  id: string,
  system: TzWalletSystem,
  authToken: string,
) {
  const cryptedId = encrypt(id);
  return await axios({
    method: 'post',
    url: `${process.env.REACT_APP_TZ_WALLET_USER_QUERY_URL || ''}`,
    data: {
      cryptedId,
      system,
    },
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}
